export default __webpack_public_path__ + "static/media/icon - SOS Bell Enabled.a62cbabf.svg";